import { create } from 'zustand';

type TPreviewerStore = {
    isPreviewerOpen: boolean;
    file: string | null;
    sourceFilePath: string | null;
    sourceFileName: string | null;
    sourceFileUrl: string | null;
    pageNumber: number;
    zIndex: number;
    onClose: () => void;
    setPreviewerState: (
        isOpen: boolean,
        file?: string | null,
        pageNumber?: number,
        closeAction?: () => void,
        zIndex?: number,
        sourceFilePath?: string | null,
        sourceFileName?: string | null,
        sourceFileUrl?: string | null,
    ) => void;
};

const usePreviewerStore = create<TPreviewerStore>((set, get) => ({
    isPreviewerOpen: false,
    file: null,
    sourceFilePath: null,
    sourceFileName: null,
    sourceFileUrl: null,
    pageNumber: 0,
    zIndex: 20,
    onClose: () => {},
    setPreviewerState: (
        isOpen,
        file = null,
        pageNumber = 0,
        closeAction,
        zIndex = 20,
        sourceFilePath = null,
        sourceFileName = null,
        sourceFileUrl = null,
    ) => {
        if (!isOpen) {
            // If closing, trigger the previous onClose function if it exists
            typeof get().onClose === 'function' && get().onClose();
        }

        set({
            isPreviewerOpen: isOpen,
            file,
            sourceFilePath,
            sourceFileName,
            sourceFileUrl,
            pageNumber,
            onClose: closeAction,
            zIndex,
        });
    },
}));

export default usePreviewerStore;
